import React, { useRef, useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import BEMHelper from '@ynap/bem-helper';

const bem = new BEMHelper('ProductGrid');

const ProductGrid = (props) => {
    const { children, className, columns = 3, url = '', setListingHeight, index, numberOfItems } = props;
    const myRef = useRef();

    useLayoutEffect(() => {
        index === 0 && setListingHeight(myRef.current.clientHeight, index);
    });

    return (
        <div ref={myRef} className={bem(null, null, className)} data-columns={columns}>
            {children}
        </div>
    );
};

ProductGrid.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    columns: PropTypes.number,
    url: PropTypes.string,
    setListingHeight: PropTypes.func,
    index: PropTypes.number,
    numberOfItems: PropTypes.number,
};
export default ProductGrid;
